import * as React from "react";
import { Route, RouteProps } from "react-router-dom";
import { useKeycloak } from "@react-keycloak/web";

const AuthRoute: React.FC<RouteProps> = ({ component, ...rest }) => {
  const { keycloak } = useKeycloak();

  return (
    <Route
      {...rest}
      render={(props) =>
        keycloak?.authenticated && <Route {...props} component={component} />
      }
    />
  );
};

export default AuthRoute;
